import React from 'react';
import {ICommentModel} from '@src/@interfaces/models/Comment/ICommentModel';
import PlainComment from '@src/components/CommentsList/PlainComment/PlainComment';
import {getUserName} from '@src/components/CommentsList/InlineUserRepresentation';
import useComment from '@src/hooks/useComment';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';
import classnames from '@src/helpers/classnames';
import Translate from '@src/components/Translate/Translate';

export default function BlockquoteOfComment(props: {
    comment: ICommentModel | undefined | null,
    className?: string,
    onClick?: () => void,
}) {
    const onClick = props.onClick;
    const replyToCommentId = props.comment?.parent_id;
    const {comment, error, isLoading} = useComment(replyToCommentId);

    const className = classnames(props.className, 'comment-list__item__blockquote', {
        'comment-list__item__blockquote--interactive': onClick && comment,
        'comment-list__item__blockquote--error': error,
    });

    if (replyToCommentId != null && isLoading) {
        return <div className={className}>
            <NowLoadingMessage justifyContent="start" paddingY={2} paddingX={0}/>
        </div>;
    }

    if (!comment && error) {
        return <Translate tag="div" message="Chat.errors.comment-not-found" className={className}/>;
    }

    if (!comment || !replyToCommentId) {
        return null;
    }

    return <figure className={className} onClick={onClick}>
        <figcaption>{getUserName(comment.creator, true)}</figcaption>
        <PlainComment comment={comment} tag="blockquote"/>
    </figure>;
}
